<template>
    <section>

        <div class="container">

            <div class="columns">
                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[0].name }}</div>
                    <div class="title">{{ indicator.count_types[0].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[1].name }}</div>
                    <div class="title">{{ indicator.count_types[1].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[2].name }}</div>
                    <div class="title">{{ indicator.count_types[2].value }}</div>
                </div>
            </div>

            <div class="columns">
                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[3].name }}</div>
                    <div class="title">{{ indicator.count_types[3].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[4].name }}</div>
                    <div class="title">{{ indicator.count_types[4].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[5].name }}</div>
                    <div class="title">{{ indicator.count_types[5].value }}</div>
                </div>
            </div>

            <div class="columns">
                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[6].name }}</div>
                    <div class="title">{{ indicator.count_types[6].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[7].name }}</div>
                    <div class="title">{{ indicator.count_types[7].value }}</div>
                </div>

                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[8].name }}</div>
                    <div class="title">{{ indicator.count_types[8].value }}</div>
                </div>
            </div>

            <div class="columns">
                <div class="column has-text-centered">
                    <div class="heading is-size-6">{{ indicator.count_types[9].name }}</div>
                    <div class="title">{{ indicator.count_types[9].value }}</div>
                </div>
            </div>


            <div class="columns is-centered">
                <div style="border: 2px solid black; border-radius:10px" class="column is-4 has-text-centered">
                    <div class="heading is-size-6">Proyectos Totales</div>
                    <div class="title">{{ indicator.total }}</div>
                </div>
            </div>
            
        </div>

    </section>
</template>

<script>
export default{
    props: [
        'indicator',
    ],
}
</script>